import axios, { AxiosResponse } from 'axios';

const baseUrl = '/files';

const getFileUrl = (uuid: string): Promise<AxiosResponse<string>> =>
  axios.get<string>(`${baseUrl}/${uuid}`);

const deleteFileById = (uuid: string): Promise<AxiosResponse<void>> =>
  axios.delete<void>(`${baseUrl}/${uuid}`);

const editFileName = (payload: {
  uuid: string;
  fileName: string;
}): Promise<AxiosResponse<void>> => axios.put<void>(`${baseUrl}`, payload);

export const fileService = {
  getFileUrl,
  deleteFileById,
  editFileName
};
